import {z} from "zod";
import {SortSchema} from "./otk-document.ts";
import {mongoObjectIdSchema} from "./mongo.ts";

export const BlankTypes = ["PROTOCOL_FORM", "ELECTRONIC_OTK_DOCUMENT"] as const;
export type BlankType = typeof BlankTypes[number];
export const blankTypeSchema = z.enum(BlankTypes);

export const BlankStatuses = [
    "IN_STOCK",
    "USED",
    "REJECTED",
    "ANNULLED",
    "DESTROYED",
    "RESERVED_BY_GSC",
] as const;
export type BlankStatus = typeof BlankStatuses[number];
export const blankStatusSchema = z.enum(BlankStatuses);

export const otkBlanksListQuerySchema = z.object({
    status: blankStatusSchema,
    type: blankTypeSchema.optional(),
    pageSize: z.coerce.number().int().min(5).max(50).default(25),
    cursor: z.string().optional(),
    sort: SortSchema.default("ASC"),
});

export type OtkBlanksListQuery = z.infer<typeof otkBlanksListQuerySchema>;

/** Blank returned by the blanks-list endpoint. */
export const otkBlankSchema = z.object({
    id: mongoObjectIdSchema,
    series: z.string(),
    number: z.string(),
    subjectId: mongoObjectIdSchema.nullable(),
    type: blankTypeSchema,
    status: blankStatusSchema,
    statusReason: z.string().nullable().optional(),
    /** Local document linkage set by the conditional `IN_STOCK` to `USED` transition. */
    documentId: z.string().nullable(),
    documentNumber: z.string().nullable(),
    signedAt: z.iso.datetime().nullable(),
    /** Candidate/accepted destruction-act linkage; its number appears after registry acceptance. */
    destructionActId: mongoObjectIdSchema.nullable(),
    destructionActNumber: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});

export type OtkBlank = z.infer<typeof otkBlankSchema>;

export interface BlanksPageResult {
    data: OtkBlank[];
    nextPage: string | null;
}
